ACDiscountApp.PDPage.DisplayTiers = function () {

  
  var storeTime = globalFields.Storetime();
  let productVariantsProduct 
  // Parse the date string into individual components
  let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
  currentYear = parseInt(currentYear);
  currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
  currentDay = parseInt(currentDay);
  currentHours = parseInt(currentHours);
  currentMinutes = parseInt(currentMinutes);
  currentSeconds = parseInt(currentSeconds);

  function makeTimer(end_date) {
    if (globalFields.isProduct_Page) {
      if (end_date != null) {
        jQuery("#ac_countDown").css("display", "block");
        var endTime = end_date;
        // Increment seconds by 1
        currentSeconds++;

        // Adjust minutes, hours, and day if necessary
        if (currentSeconds >= 60) {
          currentSeconds = 0;
          currentMinutes++;
          if (currentMinutes >= 60) {
            currentMinutes = 0;
            currentHours++;
            if (currentHours >= 24) {
              currentHours = 0;
              currentDay++;
            }
          }
        }

        // Reformat the updated timestamp
        let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
        endTime = (Date.parse(endTime) / 1000);
        var now = currentStoreTime;
        now = (Date.parse(now) / 1000);
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor(timeLeft / 3600);
        var exactHour = hours % 24;
        var minutes = Math.floor((timeLeft - (hours * 3600)) / 60);
        var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
        var isDays = false;
        if (days > 0 || hours > 24) { isDays = true; }
        if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        if (timeLeft > 0) {
          if (isDays) {
            $(".ac__days").html(days); $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes);
            $(".ac_sec, .ac__colon.seconds").hide();
          }
          else {
            $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes); $(".ac__seconds").html(seconds);
            $(".ac_day, .ac__colon.hours").hide(); $(".ac_sec, .ac__colon.seconds").show();
          }
        }
        else { jQuery('.ac__settings__table, #ac_countDown').remove(); }

        setTimeout(function () {
          jQuery('.ac__settings__table').after(jQuery("#ac_countDown"));
        }, 500);
      }
    }
  }

  var hide_buttons = null;
  var HideAdditionalPayments = function () {
    hide_buttons = setInterval(function () {
      if (jQuery('.shopify-payment-button__button').length > 0) {
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

    function shouldExcludeProduct(productId,excludeProducts) {
    const isExcluded = excludeProducts.some(product => product.id == productId);
    return !isExcluded;
}



  // This function for Highest Priority and Discount applied on check
    // Variant
   function findHighestVariantPriorityDiscount(tierVariantsArray, tierProductsArray, tierCollectionsArray, tierAllProducts) {
    const filterByDiscount = (array) => array.filter(item => (item.DiscountAppliedON === "Online_Store" || item.DiscountAppliedON === "Both_Store") && item.status === true);

    let filteredArray = filterByDiscount(tierVariantsArray);
    if (filteredArray.length === 0 && tierProductsArray.length != '[]') {
        filteredArray = filterByDiscount(tierProductsArray);
    } else if (filteredArray.length === 0 && tierCollectionsArray.length != 0) {
        filteredArray = filterByDiscount(tierCollectionsArray);
    } else if (filteredArray.length === 0 && tierAllProducts != '[]') {
        filteredArray = filterByDiscount(tierAllProducts);
    } else if (filteredArray.length === 0) {
        return null;
    }

    return filteredArray.reduce((prev, current) => (prev.priority > current.priority) ? prev : current, filteredArray[0]);
  }
    // products
    function findHighestProductsPriorityDiscount(tierproductsArray,tierCollectionsArray,tierAllProducts) {
      const filterByDiscount = (array) => array.filter(item => (item.DiscountAppliedON === "Online_Store" || item.DiscountAppliedON === "Both_Store") && item.status === true);
     let filteredArray = filterByDiscount(tierproductsArray);
     if (filteredArray.length === 0 && tierCollectionsArray.length !== 0) {
        filteredArray = filterByDiscount(tierCollectionsArray);
    } else if (filteredArray.length === 0 && tierAllProducts != '[]') {
        filteredArray = filterByDiscount(tierAllProducts);
    } else if (filteredArray.length === 0) {
        return null;
    }

    return filteredArray.reduce((prev, current) => (prev.priority > current.priority) ? prev : current, filteredArray[0]);
 }
    // Collections
    function findHighestCollectionsPriorityDiscount(tierCollectionsArray,tierAllProducts) {
     const filterByDiscount = (array) => array.filter(item => (item.DiscountAppliedON === "Online_Store" || item.DiscountAppliedON === "Both_Store") && item.status === true);
     let filteredArray = filterByDiscount(tierCollectionsArray);
     if (filteredArray.length === 0 && tierAllProducts != '[]') {
        filteredArray = filterByDiscount(tierAllProducts);
     } else if (filteredArray.length === 0) {
        return null;
    }

    return filteredArray.reduce((prev, current) => (prev.priority > current.priority) ? prev : current, filteredArray[0]);
  }
    // AllProducts
    function findHighestAllProductsPriorityDiscount(tierAllProducts) {
    const filterByDiscount = (array) => array.filter(item => (item.DiscountAppliedON === "Online_Store" || item.DiscountAppliedON === "Both_Store") && item.status === true);
     if (tierAllProducts != '[]') {
        filteredArray = filterByDiscount(tierAllProducts);
     }else if (filteredArray.length === 0) {
        return null;
    }

    return filteredArray.reduce((prev, current) => (prev.priority > current.priority) ? prev : current, filteredArray[0]);
 }
  
     // this Retun Collections Metafileds
      function getTheCollectionMetafields(arrayObj) {
    let mergedArray = arrayObj.filter(item => Array.isArray(item) && item.length > 0).reduce((acc, curr) => acc.concat(curr), []);
    return mergedArray;
   }
      var GetTiersFromTiersArray = function (variantId,productId) {
      var collectionMetafileds = getTheCollectionMetafields(globalFieldsProductPage_AC.collection_tiers);
      var { variant_tiers, product_tiers, allProduct_tiers } = globalFieldsProductPage_AC;
      if (variant_tiers != "[]") {
      const highestPriorityDiscount = findHighestVariantPriorityDiscount(variant_tiers,product_tiers,collectionMetafileds,allProduct_tiers);
      return globalFields.GetTierObject(highestPriorityDiscount, variantId);
      }else if(product_tiers != "[]"){
      const highestPriorityDiscount = findHighestProductsPriorityDiscount(product_tiers,collectionMetafileds,allProduct_tiers);
      return globalFields.GetTierObject(highestPriorityDiscount, variantId);
      }else if(collectionMetafileds.length != 0){
      const highestPriorityDiscount = findHighestCollectionsPriorityDiscount(collectionMetafileds,allProduct_tiers);
      return globalFields.GetTierObject(highestPriorityDiscount, variantId);
      }else if(allProduct_tiers != '[]'){
      const highestPriorityDiscount = findHighestAllProductsPriorityDiscount(allProduct_tiers);
      return globalFields.GetTierObject(highestPriorityDiscount, variantId);
      }else{
      return undefined;
      }
      }
  
  
  this.DisplayTiersFn = function (){
    setTimeout(function () {
      jQuery('.ac__settings__table').remove();
    var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
      let url = window.top.__st.pageurl
      if(globalFields.isCustomer && !globalFields.isCartPage){
        url = url.split('=')[1];
        
       productVariantsProduct = localStorage.getItem("productVariantsProduct1");
      if(productVariantsProduct == '' && (url == null || url == undefined || url == '' )) {
      if(url == null || url == undefined || url == '' ){productVariantsProduct=productVariants[0].id}}
      if(productVariantsProduct == null || productVariantsProduct == undefined || productVariantsProduct == '' ){productVariantsProduct = url}
      }
    customerMemberOrNot = globalFields.customerTagsCheck();
     if(customerMemberOrNot == ''  && Number(globalFields.Productid) != 7292101001370 && Number(globalFields.Productid) !=8105061449882){
     var BosPatner =  globalFieldsProductPage_AC.tiersBOSPartner != "string" ? globalFieldsProductPage_AC.tiersBOSPartner : [];
     const highestPriorityDiscountBosPatner = findHighestProductsPriorityDiscount(BosPatner,[],[]);
    tiersBOSPartnerFun(highestPriorityDiscountBosPatner,selectedVariant);
    var BOSPartnerVip =  globalFieldsProductPage_AC.tiersBOSPartnerVip != "string" ? globalFieldsProductPage_AC.tiersBOSPartnerVip : [];
    const highestPriorityDiscountBOSPartnerVip = findHighestProductsPriorityDiscount(BOSPartnerVip,[],[]);
    tiersBOSPartnerVipFun(highestPriorityDiscountBOSPartnerVip,selectedVariant);
      }
      if(selectedVariant == null || selectedVariant == undefined ) {selectedVariant = productVariantsProduct}
      localStorage.setItem("productVariantsProduct1",'');
      let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage != '' ? globalFields.TableProductPage : 'true';
      ProductPage = ProductPage == 'true' ? true : false;
      let tierObj = undefined;
       if(selectedVariant  != null){
          tierObj  = GetTiersFromTiersArray(selectedVariant,Number(globalFields.productId));
       }
      
      if (selectedVariant != null && ProductPage && tierObj != undefined) {
      // let tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
       let excludeProducts =  tierObj.excludeProducts != undefined ? tierObj.excludeProducts : [];
        let validated =  shouldExcludeProduct(globalFields.productId,excludeProducts);
       if(validated){
        var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant]; originalPrice_ = originalPrice_ / 100;
        ProductPriceCut(originalPrice_,tierObj)
         }
      }
      if (selectedVariant != null &&  tierObj != undefined && ProductPage) {
        let excludeProducts = tierObj.excludeProducts != undefined ? tierObj.excludeProducts : [];
        let validated =  shouldExcludeProduct(globalFields.productId,excludeProducts);
        let DiscountAppliedOn = false;
        let Location_Tag_s = false;
        if (tierObj != undefined) {
          DiscountAppliedOn = tierObj.DiscountAppliedON != null && tierObj.DiscountAppliedON != '' && tierObj.DiscountAppliedON != undefined ? true : false;
          Location_Tag_s = tierObj.Location_Tag_ != null && tierObj.Location_Tag_ != '' && tierObj.Location_Tag_ != undefined ? true : false;
        }
        if (DiscountAppliedOn) {
          // 1
          if (Location_Tag_s) {
            // 2
            let DiscountAppliedOnTag = tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false;

            let LocationObject = Object.keys(tierObj.Location_Tag_);
            if (LocationObject[0] == 'StoreLocation') {
              let StoreLocationcheck = tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
              if (tierObj != undefined && validated && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }
            else {
              // 3
              let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
              let CusotmerCountryLocation = globalFields.Customercountry;
              let CusotmerCityLocation = globalFields.Customercity;
              let CustomerLocationcheck_1 = (arr, arr1) => { return arr.some(item => arr1.includes(item)) };
              let CustomerLocationcheck_2 = (arr2, arr3) => { return arr2.some(item => arr3.includes(item)) };
              let CityValue = CustomerLocationcheck_1(TierLocation, CusotmerCountryLocation);
              let CountryValue = CustomerLocationcheck_2(TierLocation, CusotmerCityLocation);

              if (tierObj != undefined && validated && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }

          }
          else {
            // 4
            if (tierObj != undefined && validated && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store')) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = undefined//parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
              if (timer_settings != undefined) {
                if (timer_settings.TimerStatus) {
                  if (getDates.valid) {
                    setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                  }
                }
              }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function () {
                jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
              }, 2000);
              setTimeout(function () {
                clearInterval(hide_buttons);
              }, 5000);
            }
          }
        }
        else {
          // 5
          let temptimer = globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)
          if (tierObj != undefined && validated && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = undefined//parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
            if (timer_settings != undefined) {
              if (timer_settings.TimerStatus) {
                if (getDates.valid) {
                  setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                }
              }
            }
            jQuery('.shopify-payment-button__button').hide();
            setTimeout(function () {
              jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
            }, 2000);
            setTimeout(function () {
              clearInterval(hide_buttons);
            }, 5000);
          }
        }
      }
    }, 200);

  }


  setTimeout(function () {
    clearInterval(hide_buttons);
  }, 10000);

  this.OnVariantChange = function () {
    setTimeout(function () {
      $(".js.product-form__input label").click(function () {
        displayTiers.DisplayTiersFn();
      });
    }, 2000);
  }

  var TableHeadHtml = function (contentHtml, tableSelector, position) {
    jQuery(tableSelector).before(contentHtml)
  }

  var WriteTableHeading = function (tierObj) {
    var tableSelector = 'form[action="/cart/add"] .product-form__payment-container';
    if (globalFields.settings.selected_table == "table1") {
      TableHeadHtml('<table class="ac__settings__table ac_table1" id="ac_table1"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th></tr></tbody></table>', tableSelector);
    }
    if (globalFields.settings.selected_table == "table2") {

      TableHeadHtml('<table class="ac__settings__table ac_table2" id="ac_table2"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }

    if (globalFields.settings.selected_table == "table3") {
      TableHeadHtml('<table class="ac__settings__table ac_table3" id="ac_table3"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }

    if (globalFields.settings.selected_table == "table4") {
      TableHeadHtml('<table class="ac__settings__table ac_table4" id="ac_table4"><tbody class="ac__tbody"></tbody></table>', tableSelector);
    }
  }

  var TableRowHtml = function (contentHtml, tableSelector) {
    
    jQuery(tableSelector).append(contentHtml);
  }

  var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, booleanmostPopularValues, index) {
       if(discountedPrice == 0){return}
    var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
    var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + discountedPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
    if (globalFields.settings.selected_table == "table1") {
      if (booleanmostPopularValues) {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td></tr>', '#ac_table1 .ac__tbody');
      } else {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td></tr>', '#ac_table1 .ac__tbody');
      }

    }
    if (globalFields.settings.selected_table == "table2") {
      if (booleanmostPopularValues) {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      } else {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      }

    }

    if (globalFields.settings.selected_table == "table3") {
      if (booleanmostPopularValues) {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + priceHtml + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table3 .ac__tbody');
      } else {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + priceHtml + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table3 .ac__tbody');
      }

    }

    if (globalFields.settings.selected_table == "table4") {
      var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
      if (tieredMax_ == "+") {
        quantityTextTable4 = tieredMin_ + "+";
      }
      TableRowHtml('<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + ' ' + tieredMin_ + ' ' + globalFields.settings.table_body.body2_value + ' ' + tieredOff + '</td></tr>', '#ac_table4');
    }


  }

  var WriteTableRows = async function (tierObj, selectedVariant_) {
    var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
     let costMargin = tierObj?.costMargin ?? false;
           let costPrice = null;
         costPrice = await getCostPrice(selectedVariant_);
          if (costMargin) {
               
              if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
          }
    
    for (i = 0; i < tierObj.tier_min.length; i++) {
      var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
      var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

      if (tieredMax_ != "max") {
        tieredMax_ = parseInt(tieredMax_);
      }
      else {
        tieredMax_ = "+";
      }

      if (tierObj.discount_type == "percentage") {
        discountedPrice = Number(originalPrice_.toFixed(2));
        var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
        discountedPrice = discountedPrice - originalPriceCut_;
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = "100%";
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = tieredOff + "% OFF";
        }
      }
      else if (tierObj.discount_type == "fixed_price") {
        discountedPrice = tieredOff.toFixed(2);
        tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
      }
           else if (tierObj.discount_type == "costMargin") {
             
              if (costPrice !=  null && costPrice != 0){
               discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
                let marginCalculation = Number(costPrice) * Number(discountedPrice);
                marginCalculation = marginCalculation / 100;
               marginCalculation = marginCalculation + Number(costPrice); 
                discountedPrice = marginCalculation.toFixed(2);
                tieredOff = globalFields.formatMoney(marginCalculation.toFixed(2), globalFields.amount);
                // }
              }else{
                   if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
              }

            
          }
      else {
        discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
        }
      }

      let booleanmostPopularValues = tierObj.mostPopularValues != undefined ? (tierObj.mostPopularValues[i] != undefined ? tierObj.mostPopularValues[i] : false) : false;
      TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, booleanmostPopularValues, i + 1);

      if (isBreakLoop) { break; }
    }
   
    }
}
 
var tiersBOSPartnerFun  = async function(tierObj, selectedVariant_){
  if(tierObj && tierObj != null){
 var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
     let costMargin = tierObj != null ?  tierObj.costMargin : false;
           let costPrice = null;
         costPrice = await getCostPrice(selectedVariant_);
          if (costMargin) {
               
              if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
          }
  var updateprice = 0;
   for (i = 0; i < tierObj.tier_min.length; i++) {
      var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
      var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

      if (tieredMax_ != "max") {
        tieredMax_ = parseInt(tieredMax_);
      }
      else {
        tieredMax_ = "+";
      }

      if (tierObj.discount_type == "percentage") {
        discountedPrice = Number(originalPrice_.toFixed(2));
        var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
        discountedPrice = discountedPrice - originalPriceCut_;
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = "100%";
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = tieredOff + "% OFF";
        }
      }
      else if (tierObj.discount_type == "fixed_price") {
        discountedPrice = tieredOff.toFixed(2);
        tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
      }
           else if (tierObj.discount_type == "costMargin") {
             
              if (costPrice !=  null && costPrice != 0){
               discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
                let marginCalculation = Number(costPrice) * Number(discountedPrice);
                marginCalculation = marginCalculation / 100;
               marginCalculation = marginCalculation + Number(costPrice); 
                discountedPrice = marginCalculation.toFixed(2);
                tieredOff = globalFields.formatMoney(marginCalculation.toFixed(2), globalFields.amount);
                // }
              }else{
                   if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
              }

            
          }
      else {
        discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
        }
      }
     updateprice = tieredOff;
      if (isBreakLoop) { break; }
    }

jQuery('.product-form__info-list .product-form__info-item:first').after(
`<div class="product-form__info-item">
    <span class="product-form__info-title text--strong">BOSPartner : </span>
    <div class="product-form__info-content" role="region" aria-live="polite">
      <div class="price-list"><span class="price">${updateprice}</span>
    </div>
  </div>`);
    }
  
}

var tiersBOSPartnerVipFun  = async function(tierObj, selectedVariant_){
if(tierObj && tierObj != null){

 var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
    let costMargin = tierObj?.costMargin ?? false;
           let costPrice = null;
         costPrice = await getCostPrice(selectedVariant_);
          if (costMargin) {
               
              if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
          }
  var updateprice = 0;
   for (i = 0; i < tierObj.tier_min.length; i++) {
      var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
      var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

      if (tieredMax_ != "max") {
        tieredMax_ = parseInt(tieredMax_);
      }
      else {
        tieredMax_ = "+";
      }

      if (tierObj.discount_type == "percentage") {
        discountedPrice = Number(originalPrice_.toFixed(2));
        var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
        discountedPrice = discountedPrice - originalPriceCut_;
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = "100%";
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = tieredOff + "% OFF";
        }
      }
      else if (tierObj.discount_type == "fixed_price") {
        discountedPrice = tieredOff.toFixed(2);
        tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
      }
           else if (tierObj.discount_type == "costMargin") {
             
              if (costPrice !=  null && costPrice != 0){
               discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
                let marginCalculation = Number(costPrice) * Number(discountedPrice);
                marginCalculation = marginCalculation / 100;
               marginCalculation = marginCalculation + Number(costPrice); 
                discountedPrice = marginCalculation.toFixed(2);
                tieredOff = globalFields.formatMoney(marginCalculation.toFixed(2), globalFields.amount);
                // }
              }else{
                   if ((costPrice == 0 || costPrice == null )&& $('.ac__settings__table tr').length == 1) { //for if the cost price is equal to 0 the remove the table
                  $('.ac__settings__table').remove();
                  return;
              }
              }

            
          }
      else {
        discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
        }
      }
     updateprice = tieredOff;
      if (isBreakLoop) { break; }
    }
jQuery('.product-form__info-list .product-form__info-item:first').after( `<div class="product-form__info-item">
    <span class="product-form__info-title text--strong">BOS VIP : </span>
    <div class="product-form__info-content" role="region" aria-live="polite">
      <div class="price-list"><span class="price">${updateprice}</span>
    </div>
  </div>` )
}

}





var ProductPriceCut = async function(originalPrice_,tierObj) {
  
    let customerTag = globalFields.customerTag.split('_')[1];
if (typeof customerTag === 'undefined' || customerTag === null || customerTag === '') {
    customerTag = customerTagTheme;
}

    let productPrice = originalPrice_;
    let discountedItemPrice = tierObj.tier_values[0]
    var tierPrice = parseFloat(tierObj.tier_values[0]);


  if (tierObj.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(productPrice)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(productPrice) - originalPriceCut);
                }
                else if (tierObj.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(productPrice) - parseFloat(tierPrice));
                }
                else if (tierObj.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                }

  
  let customerTagDiscount = $('.customerTagDiscount')
    
if (customerTag == 'MEMBER') {
jQuery('.page-content--product .product-block--price').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalPrice_*100 + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalPrice_*100, globalFields.amount) + '</span></s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice*100 + '" data-currency="' + globalFields.currency + '"> ' +  globalFields.formatMoney(updatedItemPrice*100, globalFields.amount) + '</span><span class="customerTagDiscount"  style="color: red;"></span >');
 customerTagDiscount = $('.customerTagDiscount')
  customerTagDiscount = customerTagDiscount.html(`<span> MEMBER </span> ${tierObj.tier_values[0]}%</span><span">`)
} else if(customerTag == 'Retail'){
jQuery('.page-content--product .product-block--price').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalPrice_*100 + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalPrice_*100, globalFields.amount) + '</span></s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice*100 + '" data-currency="' + globalFields.currency + '"> ' +  globalFields.formatMoney(updatedItemPrice*100, globalFields.amount) + '</span><span class="customerTagDiscount"  style="color: red;"></span >');
 customerTagDiscount = $('.customerTagDiscount')
  customerTagDiscount = customerTagDiscount.html(`<span> LOYALTY </span> ${tierObj.tier_values[0]}%</span><span">`)
}
}
window.addEventListener('popstate', function(event) {
    // Reload the page when navigating backward or forward
    window.location.reload();
});

window.addEventListener('DOMContentLoaded', function() {
    var perfEntries = performance.getEntriesByType("navigation");

    if (perfEntries.length > 0 && perfEntries[0].type === 'back_forward') {
        setTimeout(() => {
            location.reload();
        }, 1300);
    }
});



$(document).ready(function() {
    $('.variant-wrapper input[type="radio"]').click(function() {
        var index = $('.variant-wrapper input[type="radio"]').index(this);
        index = Number(index)
     productVariantsProduct =  productVariants[index].id
       selectedVariant = productVariantsProduct
       localStorage.setItem("productVariantsProduct1",productVariantsProduct);
      displayTiers.DisplayTiersFn();
    });
});

       //function for get cost price 
   async  function getCostPrice(variantId){
const requestOptions = {
  method: "GET",
  redirect: "follow"
};

try {
 let resData = await fetch(`https://customerapp.anncode.com/storeFront/getVariantCost?Shop=${Shopify.shop}&variantId=${variantId}`, requestOptions);
  let costPrice = await resData.json();
  return costPrice.data;
} catch (er){
console.log("err>>>>", er)
}
}
          //end function

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();